import { render, staticRenderFns } from "./OfficialHolidaysTable.vue?vue&type=template&id=bc525f6a&"
import script from "./OfficialHolidaysTable.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports